<template>
  <b-modal
    v-model="modalVisible"
    :title="title"
    modal-class="modern-modal"
    :body-class="bodyClass || undefined"
    :size="size"
    :centered="centered"
    :hide-header-close="hideHeaderClose"
    @hidden="onModalHidden"
  >
    <!-- Custom header slot -->
    <template
      v-if="$slots.header"
      #modal-header
    >
      <slot name="header" />
    </template>

    <!-- Modal content -->
    <div class="modal-content-wrapper">
      <slot />
    </div>

    <!-- Modal footer with standard action buttons -->
    <template #modal-footer>
      <slot name="footer">
        <div class="w-100 d-flex justify-content-center">
          <b-button
            v-if="showCancel"
            variant="outline-secondary"
            class="mr-2"
            :disabled="processing"
            @click="cancelAction"
          >
            {{ cancelText }}
          </b-button>
          <b-button
            v-if="showConfirm"
            :variant="confirmVariant"
            :disabled="confirmDisabled || processing"
            @click="confirmAction"
          >
            <b-spinner
              v-if="processing"
              small
              class="mr-2"
            />
            {{ processing ? processingText : confirmText }}
          </b-button>
        </div>
      </slot>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    // Modal visibility
    show: {
      type: Boolean,
      default: false
    },

    // Modal configuration
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md'
    },
    centered: {
      type: Boolean,
      default: true
    },
    hideHeaderClose: {
      type: Boolean,
      default: false
    },

    // Button configuration
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    },
    confirmText: {
      type: String,
      default: 'Confirmar'
    },
    confirmVariant: {
      type: String,
      default: 'primary'
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },

    bodyClass: {
      type: String,
      default: ''
    },

    // Processing state
    processing: {
      type: Boolean,
      default: false
    },
    processingText: {
      type: String,
      default: 'Procesando...'
    }
  },

  computed: {
    modalVisible: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('update:show', value)
      }
    }
  },

  methods: {
    cancelAction () {
      this.$emit('cancel')
      this.$emit('update:show', false)
    },

    confirmAction () {
      this.$emit('confirm')
    },

    onModalHidden () {
      this.$emit('hidden')
      this.$emit('update:show', false)
    }
  }
}
</script>

<style>
/* Modal Styles - Remove all borders (unscoped for better specificity) */
.modern-modal .modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  /* Flex column so body can scroll while header/footer stay fixed */
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modern-modal .modal-header {
  border: none !important;
  border-bottom: none !important;
  padding: 1.5rem 1.5rem 0;
  background: transparent !important;
  flex-shrink: 0;
}

/* Body scrolls independently — footer always visible */
.modern-modal .modal-body {
  padding: 1.5rem;
  border: none !important;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.modern-modal .modal-body.modal-body--overflow-visible {
  overflow: visible;
}

.modern-modal .modal-footer {
  border: none !important;
  border-top: none !important;
  padding: 0 1.5rem 1.5rem;
  background: transparent !important;
  flex-shrink: 0;
}

/* Remove all possible border variants */
.modern-modal .modal-header,
.modern-modal .modal-footer {
  border-color: transparent !important;
  border-width: 0 !important;
}
</style>

<style scoped>
.modal-content-wrapper {
  /* Add any content-specific styling here */
}
</style>



// WEBPACK FOOTER //
// src/app/shared/components/BaseModal.vue